import { Icon } from "components/Icon/Icon";
import { IconCollection } from "components/Icon/IconCollection";
import { Popover } from "components/Popover/Popover";
import { RecordId } from "config/config";
import { logListPathFragment } from "containers/Resources/screens/ResourcesSingle/components/RecordLogList/constants";
import { Link, useRouteMatch } from "react-router-dom";
import { getWorkspaceLogsLink, mapScreensToPaths } from "utils/RouterManager/utils";
interface MatchParams {
    recordTypeName: string;
    id: string;
    additionalPath: string;
}

export const SettingsPopover = ({ workspaceID }: { workspaceID: RecordId }) => {
    const match = useRouteMatch<MatchParams>("/:recordTypeName/:id/:additionalPath");
    const additionalPath = match?.params?.additionalPath;

    const trigger = (
        <span className="iconButton">
            <Icon icon={IconCollection.settingsIcon} />
        </span>
    );

    return (
        <Popover
            trigger={trigger}
            anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
            }}
            transformOrigin={{
                vertical: -14,
                horizontal: "right",
            }}
            toggleClassName="iconButtonContainer"
            rootClassName="topbarPopover"
        >
            <ul>
                <li>
                    <Link to={mapScreensToPaths.workspaceSettings(workspaceID)}>
                        Workspace Settings
                    </Link>
                </li>
                <li>
                    <Link to={mapScreensToPaths.bundleManager(workspaceID)}>Bundle Manager</Link>
                </li>
                <li>
                    <Link
                        to={getWorkspaceLogsLink(workspaceID)}
                        style={
                            additionalPath === logListPathFragment ? { pointerEvents: "none" } : {}
                        }
                    >
                        Workspace Logs
                    </Link>
                </li>
                <li>
                    <a
                        href="/THIRD-PARTY-LICENSES.txt"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Open-source licenses
                    </a>
                </li>
            </ul>
        </Popover>
    );
};
